import React from 'react'
import update from 'immutability-helper';

export default class SingleStateListener extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render(){
        const level_state_listener = this.props.data.level_state_listener;
        const state_rule_data = this.props.data.state_rule_data;
        return (
            <singlestate key={level_state_listener.building_levels_state_id}>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <div class="col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label for="event">Event Name</label>
                            <input type="text" class="form-control" name="event" placeholder="" id="event" value={state_rule_data.state_rules_name} disabled />
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-2 col-xs-2">
                        <div class="form-group">
                            <label for="event">Priority</label>
                            <input type="text" class="form-control state-listener-priority" name="event" placeholder="" id="event" value={level_state_listener.priority} disabled />
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4">
                        <div class="form-group">
                            <label for="event">Action</label>
                            <div class="clearfix"></div>
                            <button type="button" id="delete-event" data-loading-text="Loading..." class="add-tenant btn btn-danger btn-info btn-fill pull-left" autoComplete="off" onClick={this.props.onDelete.bind(null,level_state_listener.building_levels_state_id)}>
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            </singlestate>
        )
    }
};


// WEBPACK FOOTER //
// app/components/States/SingleStateListener.jsx